import Vue from "vue";
import Router from "vue-router";
import education from "./education";
import train from "./train";
import selfExam from "./selfExam";
import { getCookies } from "@/utils/utils";
import store from "@/store/index";

Vue.use(Router);

const baseRoutes = [
  {
    path: "/loginout",
    name: "loginout",
    component: () => import("@/loginout/index"),
    meta: {
      title: "登录/注册"
    }
  }
];

const router = new Router({
  // mode: "history",
  routes: baseRoutes
});

// 白名单
let needLogin = ["loginout"];

// 动态添加路由的标志，防止重复添加
window.dynamicRoutesAdded = false;

router.beforeEach((to, from, next) => {
  let token = getCookies("token") || "";

  // 没有token时遇到白名单没有的页面，进入登录页面
  if (!token && needLogin.indexOf(to.name) === -1) {
    next({
      name: "loginout"
    });
    return;
  }

  // 动态添加路由
  if (token && !window.dynamicRoutesAdded) {
    const _auth = store.state.auth || "teach";
    let dynamicRoutes = [];
    console.log("router:" + _auth);
    if (_auth === "teach") {
      console.log("router:" + 11111);
      dynamicRoutes = education;
    } else if (_auth === "train") {
      console.log("router:" + 222222);
      dynamicRoutes = train;
    } else if (_auth === "selfExam") {
      console.log("router:" + 333333);
      dynamicRoutes = selfExam;
    } else {
      // 默认使用成教路由
      dynamicRoutes = education;
    }
    router.addRoutes(dynamicRoutes);
    window.dynamicRoutesAdded = true;
    // 重新进入当前路由，确保新路由生效
    next({ ...to, replace: true });
    return;
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js